import React, { ReactElement } from 'react';

import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { FilterAPI, Panel, Stamp, StampIcon, Token } from '@philips-emr/tws-components';
import { Color, LayoutAlign, LayoutJustify, Type } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';
import { generateUUID } from '@philips-emr/tws-utils';

import { TasksAliases as Aliases, FragmentNames } from '../../codegen';
import { Route } from '../../route';
import BaseController from '../BaseController';

import './task.css';
import { IndicatorStatus } from './task-details-controller';

interface Task {
  delayed: string;
  deadline: string;
  dsDeadline: string;
  dsStatus: string;
  ieStatus: TaskStatus;
  ieStatusIndicator: IndicatorStatus;
  nrSequenceTask: number;
  writeOffDate: string;
  nrSeqProviderIndicator: number;
  taskType: TaskType;
  nrSeqDocumentType: number;
  nrSeqActionPlan: number;
  nrSeqProviderMeetingMinute: number;
}

enum TaskStatus {
  PENDING = '2',
  AWAINTING_VALIDATION = '3',
  CLOSED = '4',
  CANCELED = '5',
}

enum TaskType {
  INDICATORS = 1,
  DOCUMENTS = 2,
  ACTION_PLAN = 3,
  MEETING_MINUTES = 4,
}

@Controller({ fragment: FragmentNames.TASKS })
class TasksController extends BaseController {

  @OnMount(Aliases.FILTER_TASKS)
  onMountFetchTasks(event: MountEvent): void {
    applicationContext.openModule('tasks', { preventNavigation: true });
    const api = event.target as FilterAPI;
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setData({ nrSeqProvider });
  }

  @OnDynamicContentRender(Aliases.CARD_TASK)
  onRenderCardTask(event: RenderEvent): void {
    if (event.data) {
      const { data, render } = event;
      const { delayed } = data as Task;
      if (delayed == 'S') {
        const token = (): ReactElement =>
          <Panel className="" uuid={generateUUID()} margin="0 0 0 1.5rem" justifyContent={LayoutJustify.CENTER} alignItems={LayoutAlign.CENTER}>
            <Token value={MessageService.translate('provider.overdue')} type={Type.DANGER} />
          </Panel>;
        render(token);
      }
    }
  }

  @OnDynamicContentRender(Aliases.FIELD_ALERT)
  onRenderAlertDelayed(event: RenderEvent): void {
    if (event.data) {
      const { data, render } = event;
      const { delayed } = data as Task;
      if (delayed == 'S') {
        const token = (): ReactElement =>
          <Panel className="" uuid={generateUUID()} justifyContent={LayoutJustify.CENTER} alignItems={LayoutAlign.END}>
            <Stamp color={Color.SAFETY_ORANGE} icon={StampIcon.WARNING} label="" />
          </Panel>;
        render(token);
      }
    }
  }

  @OnSelectItem(Aliases.DECK_TASKS)
  onClickCardVisit(event: SelectItemEvent<Task>): void {
    const { nrSequenceTask } = event.item;
    this.historyService.push(Route.TASK_DETAILS, { nrSequenceTask });
  }
}

export {
  TasksController,
  Task,
  TaskStatus,
  TaskType,
};
